import { Redirect, Route, Switch } from 'react-router';
import { useIsFeatureEnabled } from '../../feature-enablement/featureEnablement';
import {
  credentialCreateRoute,
  credentialDetailRoute,
  credentialsPath,
} from '../core';
import {
  CredentialCreatePage,
  CredentialDetailPage,
  CredentialsPage,
} from '../ui';

export const CredentialsRoutes = () => {
  const isCredentialsEnabled = useIsFeatureEnabled('integration-credentials');

  if (!isCredentialsEnabled) {
    return <Redirect to="/error?reason=not-found" />;
  }

  return (
    <Switch>
      <Route path={credentialsPath()} exact component={CredentialsPage} />
      <Route
        path={credentialCreateRoute}
        exact
        component={CredentialCreatePage}
      />
      <Route
        path={credentialDetailRoute}
        exact
        component={CredentialDetailPage}
      />
      <Route render={() => <Redirect to={credentialsPath()} />} />
    </Switch>
  );
};
